<mlp-ng-app-banner
    [appBanner]="appBanner"
    [backgroundImage]="backgroundImage"
    appPreviewImage="/ng-assets/phone-screens.png"
    downloadAndroidImg="/ng-assets/styleguide/banner/google-play-badge.svg"
    downloadIOSImg="/ng-assets/styleguide/banner/download-app.svg"
></mlp-ng-app-banner>
